// @flow
import React from 'react';
import './BadgeList.scss';

type Badge = {
  id: string,
  name: string,
  color: string,
};

type Props = {
  badges: Badge[],
  selectedBadgeId: ?string,
  onBadgeClick: (badge: Badge) => void,
};

const BadgeList = ({ badges, selectedBadgeId, onBadgeClick }: Props) => {
  return (
    <div className="BadgeList">
      <div className="badge-scroll-container">
        {badges.map(badge => (
          <button
            key={badge.id}
            className={`badge-item ${selectedBadgeId === badge.id ? 'selected' : ''}`}
            onClick={() => onBadgeClick(badge)}
          >
            <span className="badge-name">{badge.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default BadgeList;



// WEBPACK FOOTER //
// ./src/components/trending/BadgeList/BadgeList.js